import React from "react";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const REFERRAL_OPTIONS = [
  "Google Search",
  "Social Media",
  "Referral from a friend/colleague",
  "LinkedIn",
  "Blog/Article",
  "Event or Conference",
  "Existing Client",
  "Other",
];

const SOCIAL_MEDIA_OPTIONS = [
  "Yes, I have a company/person handling it",
  "Yes, but I'd like OptimaGrowth to take over",
  "Yes, and I'd like to collaborate with OptimaGrowth",
  "No, I need OptimaGrowth to handle it",
  "No, I don't need social media management",
];

const CONTENT_CREATION_OPTIONS = [
  "Yes, I have a company/person handling it",
  "Yes, but I'd like OptimaGrowth to take over",
  "Yes, and I'd like to collaborate with OptimaGrowth",
  "No, I need OptimaGrowth to handle it",
  "No, I don't need content production",
];

export const WebsiteToolsStep = ({ formData, onChange }) => (
  <div className="space-y-6">
    <div>
      <h2 className="text-xl font-semibold text-white mb-1">Website, CRM & Services</h2>
      <p className="text-gray-500 text-sm">Your current digital setup and service needs.</p>
    </div>

    <div>
      <label className="block text-sm text-gray-300 mb-1.5">What platform is your website built on? *</label>
      <Select value={formData.website_platform} onValueChange={(v) => onChange("website_platform", v)}>
        <SelectTrigger className="bg-white/5 border-white/10 text-white" data-testid="select-website-platform"><SelectValue placeholder="Select your platform" /></SelectTrigger>
        <SelectContent>{["WordPress", "Wix", "Shopify", "Squarespace", "Webflow", "Custom-built", "I don't have a website", "Other"].map((opt) => (<SelectItem key={opt} value={opt}>{opt}</SelectItem>))}</SelectContent>
      </Select>
    </div>

    <div>
      <label className="block text-sm text-gray-300 mb-1.5">If you don't have a website yet, are you planning on building one? What features do you need?</label>
      <Textarea value={formData.new_website_plans} onChange={(e) => onChange("new_website_plans", e.target.value)} placeholder="e.g. Online store with payment integration, portfolio site, booking system, etc." rows={3} className="bg-white/5 border-white/10 text-white placeholder:text-gray-600" data-testid="input-new-website-plans" />
    </div>

    <div>
      <label className="block text-sm text-gray-300 mb-1.5">Do you currently use a CRM system? If yes, which one? *</label>
      <Select value={formData.crm_system} onValueChange={(v) => onChange("crm_system", v)}>
        <SelectTrigger className="bg-white/5 border-white/10 text-white" data-testid="select-crm-system"><SelectValue placeholder="Select an option" /></SelectTrigger>
        <SelectContent>{["No, I don't use a CRM", "HubSpot", "Salesforce", "Zoho CRM", "GoHighLevel", "Pipedrive", "Monday.com", "Other CRM"].map((opt) => (<SelectItem key={opt} value={opt}>{opt}</SelectItem>))}</SelectContent>
      </Select>
    </div>

    <div>
      <label className="block text-sm text-gray-300 mb-1.5">Do you currently have a company or person managing your social media? *</label>
      <p className="text-xs text-gray-500 mb-2">Let us know if you already have this covered or if you'd like OptimaGrowth to handle it.</p>
      <Select value={formData.social_media_management} onValueChange={(v) => onChange("social_media_management", v)}>
        <SelectTrigger className="bg-white/5 border-white/10 text-white" data-testid="select-social-media"><SelectValue placeholder="Select an option" /></SelectTrigger>
        <SelectContent>{SOCIAL_MEDIA_OPTIONS.map((opt) => (<SelectItem key={opt} value={opt}>{opt}</SelectItem>))}</SelectContent>
      </Select>
    </div>

    <div>
      <label className="block text-sm text-gray-300 mb-1.5">Do you currently have monthly video and photo content production in place? *</label>
      <p className="text-xs text-gray-500 mb-2">This includes branded photography, video shoots, and visual content for marketing.</p>
      <Select value={formData.content_creation} onValueChange={(v) => onChange("content_creation", v)}>
        <SelectTrigger className="bg-white/5 border-white/10 text-white" data-testid="select-content-creation"><SelectValue placeholder="Select an option" /></SelectTrigger>
        <SelectContent>{CONTENT_CREATION_OPTIONS.map((opt) => (<SelectItem key={opt} value={opt}>{opt}</SelectItem>))}</SelectContent>
      </Select>
    </div>

    <div>
      <label className="block text-sm text-gray-300 mb-1.5">How did you hear about us? *</label>
      <Select value={formData.referral_source} onValueChange={(v) => onChange("referral_source", v)}>
        <SelectTrigger className="bg-white/5 border-white/10 text-white" data-testid="select-referral-source"><SelectValue placeholder="Select one" /></SelectTrigger>
        <SelectContent>{REFERRAL_OPTIONS.map((opt) => (<SelectItem key={opt} value={opt}>{opt}</SelectItem>))}</SelectContent>
      </Select>
    </div>
  </div>
);
